module.exports = __webpack_public_path__ + "static/Juego-4cb231d837ca89432653c71dae4c649e.gif";